import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { Location } from '@angular/common';
@Injectable({
    providedIn: 'root',
})
export class LoginDeactivateGuard implements CanActivate {
    constructor(
        private authSvc: MsalService,
        private router: Router,
        private _location: Location
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.authSvc?.instance?.getActiveAccount()?.idTokenClaims?.name != null) {
            this._location.back();
        }
        return true;
    }
}
